import React, { Children } from "react";
import PropTypes from "prop-types";

import styles from "./SummeryWizard.module.scss";
import { CustomContainer } from '../../atoms/DependencyHelper';
import WizardSection from "./WizardSection";

const SummeryWizard = (props) => {
  let newStepNumber = 0;
  const childCount = Children.count(props.children);

  const upgradedChildren = Children.map(props.children, (child, index) => {

    if (
      !React.isValidElement(child)
      || child.type.name !== WizardSection.name
      || child.props.isSectionHidden
    ) return;

    const { showAsSubsection, stepNumber } = child.props;
    const isLast = (index + 1) === childCount;

    if (!showAsSubsection) newStepNumber++;

    return React.cloneElement(child, { stepNumber: stepNumber || newStepNumber, isLast });
  });

  return (
    <CustomContainer className={styles["summary-wizard-container"]}>
      { upgradedChildren }
    </CustomContainer>
  );
}

SummeryWizard.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]).isRequired,
}

SummeryWizard.defaultProps = {
  isSectionHidden: false,
};

export default SummeryWizard;
